import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useSEO } from "@/lib/seo";

const H2 = ({ children }) => <h2 className="font-display font-bold text-2xl mt-10 mb-3 text-white">{children}</h2>;
const P = ({ children }) => <p className="text-zinc-400 leading-relaxed mb-4">{children}</p>;

const TermsOfService = () => {
  const navigate = useNavigate();
  useSEO({
    title: "Terms & Conditions | BrandToBuilt",
    description: "The terms that apply when you buy a package or care plan from BrandToBuilt.",
    path: "/terms",
  });

  return (
    <div className="pt-28 md:pt-36 pb-24 min-h-screen" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <button onClick={() => navigate(-1)} className="inline-flex items-center gap-2 text-zinc-400 hover:text-[#ccff00] transition-colors mb-8" data-testid="terms-back">
          <ArrowLeft size={16} /> Back
        </button>
        <h1 className="font-display font-black tracking-tighter text-4xl md:text-5xl mb-4">Terms & Conditions</h1>
        <p className="text-zinc-500 text-sm mb-10">Last updated: 31 August 2026</p>

        <H2>Who we are</H2>
        <P>BrandToBuilt is a trading name of Ainsleys Touch Ltd (company number 17294211), registered office 66 Paul Street, London, England, EC2A 4NA. By buying a package or plan from us, you agree to these terms.</P>

        <H2>Our services</H2>
        <P>We sell one-off launch packages (website, branding, domain, socials and related add-ons) and ongoing monthly care plans (hosting, maintenance and support). Turnaround times vary by package: Launch is live within 48 hours (limited to 2 fast-track slots per day), Business within 3 days, Brand & Business within 5 days, and Launch Everything within 7 days. The clock starts once we have everything we need from you — not from the moment you pay.</P>

        <H2>Payment</H2>
        <P>All payments are processed securely via Stripe. Prices are shown in GBP and include everything listed on the package unless stated otherwise. Promo and referral codes are subject to availability and may be withdrawn at any time.</P>

        <H2>Cancellations & refunds</H2>
        <P>One-off packages: once we've started work, completed stages are non-refundable. If we haven't started yet, contact us for a full refund. Monthly plans: you can cancel anytime from your billing portal or by emailing us — you won't be charged again, but we don't refund the current billing period, and your plan stays active until the end of it.</P>

        <H2>Ownership</H2>
        <P>Once a package is paid in full, the website, logo and brand assets we create are yours to keep and use. Ongoing hosting and edits require an active care plan; if you cancel, we'll help you export or move your site where reasonably possible.</P>

        <H2>Referral program</H2>
        <P>Referral codes are intended for genuine personal recommendations. We reserve the right to void codes or rewards used in a way that abuses the spirit of the program.</P>

        <H2>Liability</H2>
        <P>We aim for accuracy and quality in everything we build, but we can't guarantee specific business outcomes such as traffic, leads or search rankings. Our liability to you is limited to the fees you've paid us.</P>

        <H2>Changes to these terms</H2>
        <P>We may update these terms from time to time. We'll email you if we make a material change that affects an active plan.</P>

        <H2>Governing law</H2>
        <P>These terms are governed by the laws of England and Wales.</P>

        <H2>Contact</H2>
        <P>Ainsleys Touch Ltd, 66 Paul Street, London, England, EC2A 4NA — <a href="mailto:hello@brandtobuilt.co.uk" className="text-[#ccff00] underline">hello@brandtobuilt.co.uk</a></P>
      </div>
    </div>
  );
};

export default TermsOfService;
